module.exports = __webpack_public_path__ + "img/mobile-mask.2e06f394.svg";